'use client';
import { __assign } from "tslib";
import React, { useEffect, useRef, useState } from 'react';
import { classNames, Div, Text } from '@pezeshk-book/ui-kit';
var CountDown = function (_a) {
    var sec = _a.sec, parentCallback = _a.parentCallback, reset = _a.reset, _b = _a.variant, variant = _b === void 0 ? 'contained' : _b, className = _a.className, textProps = _a.textProps, _c = _a.initialColor, initialColor = _c === void 0 ? 'primary' : _c;
    var _d = useState(sec), timerSec = _d[0], setTimerSec = _d[1];
    var _e = useState(0), timerMin = _e[0], setTimerMin = _e[1];
    var _f = useState(0), timerHour = _f[0], setTimerHour = _f[1];
    var _g = useState(initialColor), color = _g[0], setColor = _g[1];
    useEffect(function () {
        if (sec >= 3600) {
            setTimerHour(Math.floor(sec / 3600));
            setTimerMin(Math.floor((sec % 3600) / 60));
            setTimerSec(Math.floor((sec % 3600) % 60));
        }
        else {
            setTimerMin(Math.floor(sec / 60));
            setTimerSec(Math.floor(sec % 60));
        }
    }, [reset]);
    var id = useRef(null);
    var clear = function () {
        // @ts-ignore
        clearInterval(id.current);
    };
    useEffect(function () {
        // @ts-ignore
        id.current = setInterval(function () {
            setTimerSec(function (time) { return time - 1; });
        }, 1000);
        return function () { return clear(); };
    }, [reset]);
    useEffect(function () {
        if (timerSec === 0 && timerMin === 0 && timerHour === 0) {
            parentCallback(true);
            clear();
        }
        else if (timerSec === -1 && timerMin !== 0) {
            setTimerSec(59);
            setTimerMin(function (time) { return time - 1; });
        }
        else if (timerSec === -1 && timerMin === 0 && timerHour !== 0) {
            setTimerSec(59);
            setTimerMin(59);
            setTimerHour(function (time) { return time - 1; });
        }
        var remainingTime = (timerSec + timerMin * 60 + timerHour * 3600);
        setColor((remainingTime <= (sec / 10) ? 'danger' : (remainingTime <= (sec * 30 / 100) ? 'warning' : initialColor)));
    }, [timerSec]);
    return (React.createElement(Div, { dir: 'rtl', className: classNames('items-center justify-center h-full rounded', variant === 'contained' ? 'bg-primary' : 'bg-transparent', className) },
        React.createElement(Text, __assign({ typography: 'base', color: variant === 'contained' ? 'white' : color }, textProps), timerSec < 10 ? '0' + timerSec : timerSec),
        React.createElement(Text, __assign({ className: 'mx-1', typography: 'base', color: variant === 'contained' ? 'white' : color }, textProps), ":"),
        React.createElement(Text, __assign({ typography: 'base', color: variant === 'contained' ? 'white' : color }, textProps), timerMin < 10 ? '0' + timerMin : timerMin),
        sec >= 3600
            ? React.createElement(React.Fragment, null,
                React.createElement(Text, __assign({ className: 'mx-1', typography: 'base', color: variant === 'contained' ? 'white' : color }, textProps), ":"),
                React.createElement(Text, __assign({ typography: 'base', color: variant === 'contained' ? 'white' : color }, textProps), timerHour < 10 ? '0' + timerHour : timerHour)) : null));
};
export default CountDown;
//# sourceMappingURL=countdown.js.map